var GameModes;
(function (GameModes) {
    GameModes["Real"] = "real";
    GameModes["Fun"] = "fun";
})(GameModes || (GameModes = {}));

export { GameModes };
